import micahPic from "@/public/images/artists/micah.png";
import { Artist } from "@/types/types";

export const micah = {
  id: "200",
  name: "Micah",
  image: micahPic,
  description: `Micah's voice has a smooth, buoyant falsetto that rises above the mix. His unique high-register delivery makes melodic hooks pop and gives any track a joyful, bright vibe.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmicah-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Falsetto", "Ballads", "Pop", "Dance"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "High",
        high: "Very high",
      },
      specific: {
        low: 51,
        high: 78,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
